import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, cloneDeep } from 'lodash';

import '../scss/index.scss';
import Color from '@tool/color';
import { CloseIcon20, LightIcon } from '@styled/icon';
import { locateValue, newRate } from '@tool/index';
import PDF from '../../../component/pdf';
import Title from '../../../component/title';
import HeadPdf from '../../../component/head-pdf';
import FootPdf from '../../../component/foot-pdf';
import moIndex from '../../../store/index';
import moFreshCategory from './store';
import Empty from '@comp/empty/index';
import moUser from '@store/user';
import Chart from './chart';
import FreshTable from '../../fresh-table';
import Explain from './explain';

interface IProps {}
interface IState {}

const SalaryIndustryPDF = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { industry, freshYear } = moIndex;
  const {
    xData, yData, labels, overview,
    tableHead, tableList,
  } = moFreshCategory;
  const { isMock } = moIndex;

  useEffect(() => {
    return () => {};
  }, []);

  const pdfLog = () => {
    const newData: any[] = cloneDeep(moFreshCategory.xData.slice(10));
    const text: any[] = [];
    for (let i = 0; i < Math.ceil(newData.length / 10); i += 1) {
      const firstData = newData.slice(5 * i + 5 * i, 5 * i + 5 * i + 5);
      const secondData = newData.slice(5 * i + 5 * i + 5, 5 * i + 5 * i + 10);

      text.push(
        <PDF key={i}>
          <section className="fresh-salary_101">
            <HeadPdf onetitle="人力资源核心指标" twotitle={industry.name} />
            <section className="content-101101">
              <section className="up-rate_101101">
                {!isEmpty(xData) ? (
                  <section className="box-101101">
                    <section className={[
                      'box-13', !isMock ? '' : 'mock-100',
                    ].join(' ')}
                    style={{ overflowY: 'auto' }}>
                      <section className="chart-title_03">
                        {labels.map((item: any, idx: number) => (
                          <p key={idx} className="line-03">
                            <strong>{locateValue(item?.value)}</strong>
                            <span>{item?.text}</span>
                          </p>
                        ))}
                      </section>
                      <section style={{ width: '100%', overflowY: 'auto' }}>
                        {!isEmpty(firstData) ? (
                          <Chart height={300} idx={i + 1} index={1}
                            xData={firstData} yData={yData} />
                        ) : null}
                        {!isEmpty(secondData) ? (
                          <Chart height={300} idx={i + 1} index={2}
                            xData={secondData} yData={yData} />
                        ) : null}
                      </section>
                    </section>
                  </section>
                ) : (<Empty padding="50px 0" />)}
              </section>
            </section>
            <FootPdf />
          </section>
        </PDF>,
      );
    }
    return text;
  };

  return (
    <>
      <PDF>
        <section className="fresh-salary_101">
          <HeadPdf onetitle="人力资源核心指标" twotitle={industry.name} />
          <section className="content-101101">
            <section className="title-101101">
              <Title title="应届生起薪 - 按职能" bigTitle="人力指标" tag={`${freshYear}届`} />
            </section>

            <section className="up-rate_101101">
              {!isEmpty(xData) ? (
                <section className="box-101101">
                  <section className={[
                    'box-13', !isMock ? '' : 'mock-100',
                  ].join(' ')}
                  style={{ overflowY: 'auto' }}>
                    <section className="chart-title_03">
                      {labels.map((item: any, idx: number) => (
                        <p key={idx} className="line-03">
                          <strong>{locateValue(item?.value)}</strong>
                          <span>{item?.text}</span>
                        </p>
                      ))}
                    </section>
                    <section style={{ width: '100%', overflowY: 'auto' }}>
                      <Chart height={300} idx={0} index={0}
                        xData={xData.slice(0, 5)} yData={yData} />
                      {xData.length > 5 ? (
                        <Chart height={300} idx={1} index={0}
                          xData={xData.slice(5, 10)} yData={yData} />
                      ) : null}
                    </section>
                  </section>

                  {tableList.length <= 5 ? (
                    <FreshTable tableHead={tableHead} tableList={tableList.slice(0, 6)} />
                  ) : null}
                  {overview.length <= 2 ? <Explain /> : null}
                </section>
              ) : (<Empty padding="50px 0" />)}
            </section>
          </section>
          <FootPdf />
        </section>
      </PDF>

      {xData.length > 10 ? pdfLog() : null}
    </>
  );
};

export default observer(SalaryIndustryPDF);
